import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef, useState } from 'react';
import { useComponentDefaultProps, ColorSwatch, Popover, SimpleGrid, ColorPicker, Tooltip, Group, ActionIcon } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconX, IconCircleOff, IconColorPicker, IconPalette, IconCheck } from '@tabler/icons-react';
import { Control } from '../Control/Control.js';
import { useRichTextEditorContext } from '../../RichTextEditor.context.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var defaultProps = {};
var ColorPickerControl = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("RichTextEditorColorPickerControl", defaultProps, props),
      popoverProps = _a.popoverProps,
      colors = _a.colors,
      colorPickerProps = _a.colorPickerProps,
      others = __objRest(_a, ["popoverProps", "colors", "colorPickerProps"]);

  var _useRichTextEditorCon = useRichTextEditorContext(),
      editor = _useRichTextEditorCon.editor,
      labels = _useRichTextEditorCon.labels,
      unstyled = _useRichTextEditorCon.unstyled;

  var _useDisclosure = useDisclosure(false),
      _useDisclosure2 = _slicedToArray(_useDisclosure, 2),
      opened = _useDisclosure2[0],
      _useDisclosure2$ = _useDisclosure2[1],
      toggle = _useDisclosure2$.toggle,
      close = _useDisclosure2$.close;

  var _useState = useState("palette"),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var currentColor = (editor == null ? void 0 : editor.getAttributes("textStyle").color) || "#000";

  var handleChange = function handleChange(value) {
    var shouldClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    editor.chain().focus().setColor(value).run();
    shouldClose && close();
  };

  var handleClear = function handleClear() {
    editor.chain().focus().unsetColor().run();
    close();
  };

  var controls = colors.map(function (color, index) {
    return /* @__PURE__ */React.createElement(ColorSwatch, {
      key: index,
      component: "button",
      color,
      onClick: function onClick() {
        return handleChange(color);
      },
      size: 26,
      radius: "xs",
      sx: {
        cursor: "pointer"
      },
      title: labels.colorPickerColorLabel(color),
      "aria-label": labels.colorPickerColorLabel(color),
      unstyled
    });
  });
  return /* @__PURE__ */React.createElement(Popover, __spreadValues({
    opened,
    withinPortal: true,
    trapFocus: true,
    onClose: close,
    unstyled
  }, popoverProps), /* @__PURE__ */React.createElement(Popover.Target, null, /* @__PURE__ */React.createElement(Control, __spreadProps(__spreadValues({
    "aria-label": labels.colorPickerControlLabel,
    title: labels.colorPickerControlLabel
  }, others), {
    ref,
    onClick: toggle
  }), /* @__PURE__ */React.createElement(ColorSwatch, {
    color: currentColor,
    size: 14,
    unstyled
  }))), /* @__PURE__ */React.createElement(Popover.Dropdown, {
    sx: function sx(theme) {
      return {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
      };
    }
  }, state === "palette" && /* @__PURE__ */React.createElement(SimpleGrid, {
    cols: 7,
    spacing: 2
  }, controls), state === "colorPicker" && /* @__PURE__ */React.createElement(ColorPicker, __spreadValues({
    defaultValue: currentColor,
    onChange: function onChange(value) {
      return handleChange(value, false);
    },
    unstyled
  }, colorPickerProps)), /* @__PURE__ */React.createElement(Tooltip.Group, {
    closeDelay: 200
  }, /* @__PURE__ */React.createElement(Group, {
    position: "right",
    spacing: "xs",
    mt: "sm"
  }, state === "palette" && /* @__PURE__ */React.createElement(ActionIcon, {
    variant: "default",
    onClick: close,
    unstyled,
    title: labels.colorPickerCancel,
    "aria-label": labels.colorPickerCancel
  }, /* @__PURE__ */React.createElement(IconX, {
    stroke: 1.5,
    size: "1rem"
  })), /* @__PURE__ */React.createElement(ActionIcon, {
    variant: "default",
    onClick: handleClear,
    unstyled,
    title: labels.colorPickerClear,
    "aria-label": labels.colorPickerClear
  }, /* @__PURE__ */React.createElement(IconCircleOff, {
    stroke: 1.5,
    size: "1rem"
  })), state === "palette" ? /* @__PURE__ */React.createElement(ActionIcon, {
    variant: "default",
    onClick: function onClick() {
      return setState("colorPicker");
    },
    unstyled,
    title: labels.colorPickerColorPicker,
    "aria-label": labels.colorPickerColorPicker
  }, /* @__PURE__ */React.createElement(IconColorPicker, {
    stroke: 1.5,
    size: "1rem"
  })) : /* @__PURE__ */React.createElement(ActionIcon, {
    variant: "default",
    onClick: function onClick() {
      return setState("palette");
    },
    unstyled,
    "aria-label": labels.colorPickerPalette,
    title: labels.colorPickerPalette
  }, /* @__PURE__ */React.createElement(IconPalette, {
    stroke: 1.5,
    size: "1rem"
  })), state === "colorPicker" && /* @__PURE__ */React.createElement(ActionIcon, {
    variant: "default",
    onClick: close,
    unstyled,
    title: labels.colorPickerSave,
    "aria-label": labels.colorPickerSave
  }, /* @__PURE__ */React.createElement(IconCheck, {
    stroke: 1.5,
    size: "1rem"
  }))))));
});
ColorPickerControl.displayName = "@mantine/tiptap/ColorPickerControl";
export { ColorPickerControl };